import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.DEFAULT,
    alt: 'storage and shipping services page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'storage and shipping services page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Comprehensive <span>Storage</span><span>and Shipping Services</span>',
  description:
    'Discover secure, affordable storage and shipping with ShipAndStorage. We offer flexible plans, global reach, and unmatched convenience for all.',
  image: {
    url: '/images/v2/pages/landing-pages/storage-and-shipping-services/hero-image.jpg',
    alt: 'Comprehensive Storage and Shipping Services'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Get Started with Storage & Shipping' }
}

export const ourProcessSectionContent = {
  title: 'How We Ensure Fast Storage and Shipping Solutions',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Request a Pickup' },

  image: {
    url: '/images/v2/pages/landing-pages/storage-and-shipping-services/how-we-ensure-fast-storage-and-shipping-solutions.png',
    alt: 'How We Ensure Fast Storage and Shipping Solutions'
  },

  articles: [
    {
      id: 1,
      title: 'Book a Pickup',
      description: 'Schedule a pickup through our website or by phone at a time that works best for you.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-services/book-a-pickup.png',
        alt: 'Book a Pickup'
      }
    },
    {
      id: 2,
      title: 'Professional Handling',
      description: 'Our team carefully collects, packs, and transports your items to our secure storage facility.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-services/professional-handling.png',
        alt: 'Professional Handling'
      }
    },
    {
      id: 3,
      title: 'Secure Storage',
      description:
        'Your belongings are stored in climate-controlled units, ensuring their safety and accessibility whenever needed.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-services/secure-storage.png',
        alt: 'Secure Storage'
      }
    }
  ]
}

export const affordableStorageSectionContent = {
  id: 1,
  title: 'Affordable Storage and Shipping Solutions',
  description:
    'At ShipAndStorage, we offer cost-effective Storage and Shipping Services without compromising on quality. Whether you’re storing a single box or shipping multiple large packages, our services are designed to cater to diverse needs. We provide competitive pricing and transparent rates, ensuring you get the best value for your money.',
  image: {
    src: '/images/v2/pages/landing-pages/storage-and-shipping-services/affordable-storage-and-shipping-solutions.jpg',
    alt: 'Affordable Storage and Shipping Solutions'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Storage and Shipping Services',

  cards: [
    {
      id: 1,
      title: 'Convenience',
      description:
        'We take the hassle out of storage and shipping. From doorstep pickup to scheduled deliveries, our process is seamless and tailored to suit your schedule.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-services/convenience.png',
        alt: 'Convenience'
      }
    },
    {
      id: 2,
      title: 'Secure Storage',
      description:
        'Our facilities have advanced security with 24/7 surveillance and climate control, ensuring your items stay safe and in excellent condition.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-services/secure-storage2.png',
        alt: 'Secure Storage'
      }
    },
    {
      id: 3,
      title: 'Flexible Options',
      description:
        'Whether you need short-term storage for a few weeks or a long-term plan for several months, we offer customizable solutions to fit your unique requirements.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-services/flexible-options.png',
        alt: 'Flexible Options'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Choose Us for Storage Unit With Shipping Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Students',
          description:
            'Moving in and out of dorms or studying abroad can be challenging. Our services make storing and shipping belongings easy and affordable for students.'
        },
        {
          id: 2,
          title: 'Travelers',
          description:
            'Long-term travelers and frequent flyers can store their luggage securely and ship it when needed, saving on airline baggage fees.'
        },
        {
          id: 3,
          title: 'Businesses',
          description:
            'From managing inventory to archiving files, businesses can count on us for safe and efficient storage solutions.'
        },
        {
          id: 4,
          title: 'Homeowners',
          description:
            'Whether you’re renovating, decluttering, or downsizing, our storage and shipping services provide the flexibility you need.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-services/who-should-choose-us-for-storage-and-shipping-services-services.jpg',
        alt: 'Who Should Choose Us for Storage Unit With Shipping Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Different Storage Services',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solution',
      description:
        'Our storage solutions serve companies of all sizes, allowing you to securely store inventory, promotional materials, or office supplies and ship them as needed.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-services/business-storage-solution.png',
        alt: 'Business Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Business Storage' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description:
        'Our moving storage services provide convenient temporary storage for your belongings during the transition. Enjoy flexible durations and reliable shipping for a stress-free move.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-services/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Moving Storage' }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description:
        'Our luggage and box shipping services handle everything with care, perfect for travelers, students, and families seeking reliable solutions.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-services/luggage-and-box-shipping-services.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Luggage & Box Shipping' }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description:
        'Homeowners can use our storage services during renovations, seasonal cleanups, or downsizing. Your items are stored securely and returned when needed.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-services/residential-storage-services.png',
        alt: 'Residential Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Residential Storage' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Storage and Shipping Services?',

  image: {
    url: '/images/v2/pages/landing-pages/storage-and-shipping-services/why-choose-shipandstorage-for-storage-and-shipping-services.jpg',
    alt: 'Why Choose ShipAndStorage for Storage and Shipping Services?'
  },

  articles: [
    {
      id: 1,
      title: 'Comprehensive Solutions',
      description:
        'From small-scale storage to large-scale shipping, we handle it all, ensuring a smooth and stress-free experience for our clients.'
    },
    {
      id: 2,
      title: 'Flexible Storage Plans',
      description:
        'Choose from a range of storage durations and box sizes to suit your specific needs, offering unparalleled freedom.'
    },
    {
      id: 3,
      title: 'Global Reach',
      description:
        'With access to over 220 destinations worldwide, we provide reliable Storage and Shipping Services no matter where you’re located.'
    },
    {
      id: 4,
      title: '24/7 Customer Support',
      description:
        'Our dedicated support team is always available to address your concerns, ensuring complete peace of mind throughout the process.'
    },
    {
      id: 5,
      title: 'Affordable Pricing',
      description:
        'Our transparent pricing structure ensures you don’t face any hidden costs. Get premium services at rates that fit your budget.'
    },
    {
      id: 6,
      title: 'Eco-Friendly Practices',
      description:
        'We prioritize sustainability by using eco-friendly packaging materials and reducing our carbon footprint in every shipment.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Instant Payment Solutions for Your Needs',
  description:
    'Comprehensive storage and shipping services for all your needs. Fast, secure, and affordable solutions for shipping and storing your belongings.',
  image: {
    src: '/images/v2/pages/landing-pages/storage-and-shipping-services/instant-payment-solutions-for-your-needs.png',
    alt: 'Instant Payment Solutions for Your Needs'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Start Collecting Payments Now' }
}

export const ourPartnersSectionContent = {
  description:
    'At ShipAndStorage, we are proud to partner with leading global carriers such as FedEx, DHL, and UPS to deliver exceptional shipping and storage solutions.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'Founded in 1971 by Frederick W. Smith, FedEx began with just 186 packages and has evolved into a global shipping leader. Today, it operates a fleet of 696 aircraft and 215,000 vehicles, handling approximately 16 million shipments daily across more than 220 countries and territories. With over 550,000 employees and 5,000 locations worldwide, FedEx is committed to reliable and timely deliveries.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more details, <a href='https://www.fedex.com/en-us/home.html' target='_blank'>visit FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL Express, a key division of Deutsche Post DHL Group, is renowned for its international courier, parcel, and express mail services. As a logistics leader, DHL manages over 1.8 billion parcels annually. Founded by Adrian Dalsey, Larry Hillblom, and Robert Lynn, DHL became a wholly-owned subsidiary of Deutsche Post in 2002 and operates in more than 220 countries, playing a crucial role in the global supply chain.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, <a href='https://www.fedex.com/en-us/home.html' target='_blank'>visit DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'Originally established as the American Messenger Company in Seattle in 1907 by teenagers Claude Ryan and Jim Casey, UPS rebranded to United Parcel Service (UPS) in 1919. Today, UPS is one of the largest shipping companies worldwide, delivering around 25 million packages daily. With a workforce of over 500,000 employees globally, UPS serves more than 220 countries and territories, providing extensive global reach.',
        '<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy of the information provided. For further details, <a href="https://www.fedex.com/en-us/home.html" target="_blank">visit UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved.' //+
      ]
    }
  ]
}
